import React, { useEffect, useState } from 'react';
import "./selecticon.scss";
import heart from '../../assets/svg/ic-medicine-heart-hear.svg';

//{ placeholder, value, onChange, onKeyUp }
const InputIcon = ( { data, change, value, placeholder, icon, theme, label, opcional, style, disabled } ) => {
    
    const [ dados, setDados ] = useState([]);

    useEffect(() =>{
        if(data && data.length>0)
            setDados(data);
        // console.log('set data',data)
    }, [data]);

    useEffect(() => {
        console.log(1235,value)
     },[value])

    const renderStyle = () => {
        let stl = "gb-cont-select";
        if(theme){
            if(theme==2)
                stl =  stl + " gb-cont-select-theme2";
        }

        return stl;
    }

    const renderSelect = () => {
        return(
            <div className={renderStyle()} style={style||null}>
                <div className="gb-input-icon">
                    {icon && typeof icon === 'string' && icon.indexOf('/') < 0 ? (<i className={icon} />) : (
                        <img src={icon ? icon : heart} width="20" height="20" />)}
                </div>
                <select onChange={(ev) => {  change(ev) }} disabled={disabled}>
                    {placeholder && placeholder != '' ? (<option value="">{placeholder}</option>) : null}
                    {dados ? dados.map((item, index) => {
                        return(
                            <option value={item.id} selected={item.id===value?'selected':undefined}  key={`${index}_${item.id}`}>
                                {item.descricao}
                            </option>
                        )}
                    ): null}
                </select>
            </div>
        );
    }

    const renderSelectWithLabel = () => {
        return (
            <div>
                <label className="gb-input-label">{label}{opcional?<span style={{opacity:0.46, fontStyle:'italic', fontSize:14}}> - Opcional</span>:''}</label>
                {renderSelect()}
            </div>
        )
    }

    const renderAll = () => {
        if(theme){
            if(theme == 2)
                return renderSelectWithLabel();
            else return renderSelect();
        }else return renderSelect();
    }

    return (
        <>
            {renderAll()}
        </>
    )

    // return(
    //     <div className="box">
    //         <div className="gb-input-icon">
    //             <img src={icon?icon:heart} height="20"/>
    //         </div>
    //         <select onChange={change} value={value}>
    //             <option value="">{placeholder}</option>
    //             {dados ? dados.map((item, index) => {
    //                 return(
    //                     <option value={item.id} key={item.id}>
    //                         {item.descricao}
    //                     </option>
    //                 )}
    //             ): null}
    //         </select>
    //     </div>
    // )
}

export default InputIcon;